// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_17510KfcpRvRK4u5m6c2O9","menu-title-loyalty-row":"_30v1VgvEfCbUzX16wenzf0"};